import { render, staticRenderFns } from "./eventTypeRecipients.vue?vue&type=template&id=7ccff0e2&scoped=true&"
import script from "./eventTypeRecipients.vue?vue&type=script&lang=js&"
export * from "./eventTypeRecipients.vue?vue&type=script&lang=js&"
import style0 from "./eventTypeRecipients.vue?vue&type=style&index=0&id=7ccff0e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccff0e2",
  null
  
)

export default component.exports